import React from "react";
import { Container, PrimaryDataTable, TableColumn, TableRow } from "@component";
import { Bucket, Code, NumberBucket, SearchResponse } from "@type";
import { getContentType } from "@util";

interface Props {
  data?: SearchResponse
  dataCount?: SearchResponse
  types?: Array<Code>
  isLoading: boolean
}

const CategoryStatisticsPresenter = ({ data, dataCount, types, isLoading }: Props) => {
  return (
    <Container>
      <PrimaryDataTable
        title={"카테고리 성향"}
        pagination={false}
        headers={["카테고리", "누적횟수", "비율"]}
        useKeyword={false}
        dateType={'date'}
        selectItems={[
          {
            label: '선호/비선호',
            key: 'condition',
            items: [
              {
                label: '선호 카테고리',
                value: 'POSITIVE'
              },
              {
                label: '비선호 카테고리',
                value: 'NEGATIVE'
              }
            ]
          }
        ]}
        isLoading={isLoading}>
        {
          data ? data.aggregations.asMap[0].buckets
            .map((bucket: Bucket, index) => {
            const { key, aggregations } = bucket;
            const { value } = aggregations.asMap[1] as NumberBucket
            const totalCount = dataCount?.aggregations.asMap[0].value
            const percentage = totalCount ? value / totalCount * 100 : 0
            return (
              <TableRow
                key={index}
                enableDetailButton={true}
                enableOverlay={false}
                onClickDetailButton={() => {}}>
                <TableColumn align={"center"}>{ getContentType(Number.parseInt(key), types) }</TableColumn>
                <TableColumn align={"center"}>{ value }건</TableColumn>
                <TableColumn align={"center"} percentage={percentage}>{ percentage.toFixed(1) }%</TableColumn>
              </TableRow>
            )
          }) : <></>
        }
      </PrimaryDataTable>
    </Container>
  )
}

export default CategoryStatisticsPresenter
